import React, { useEffect, useState } from "react";
import Alert from "react-bootstrap/Alert";
import "./alertCustom.scss";

const AlertCustom = ({ key, title, message, variant = "success", onClose = null }) => {
  const [show, setShow] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      if(onClose != null){
        onClose();
      }
      
    }, 5000);

    // return () => clearTimeout(timer);
  }, [onClose]);

  const handleManualClose = () => {
    setShow(false);
    if(onClose != null){
      onClose();
    }
  };

  return (
    <>
      {show && (
        <Alert
          variant={variant}
          onClose={handleManualClose}
          dismissible
          className="alert-animated"
        >
          {title && <Alert.Heading>{title}</Alert.Heading>}
          <p>{message} {key}</p>
        </Alert>
      )}
    </>
  );
};

export default AlertCustom;
